import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Input extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    onUpdate: PropTypes.func,
    disabled: PropTypes.bool,
    prefix: PropTypes.any,
    postfix: PropTypes.any,
    tabIndex: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.inputElement = React.createRef();
  }
  
  componentDidUpdate (prevProps, prevState) {
    if (this.props.value !== prevProps.value && this.inputElement.current) {
      this.inputElement.current.value = this.props.value;
    }
  }

  render () {
    return (
      <label className={this.props.className} htmlFor={this.props.id}>
        {this.props.prefix && <span style={{marginRight: 5}}>{this.props.prefix}</span>}
        <input
          ref={this.inputElement}
          className="form-control"
          id={this.props.id}
          type={this.props.type}
          name={this.props.id}
          disabled={this.props.disabled}
          defaultValue={this.props.value}
          placeholder={this.props.placeholder}
          step={this.props.step}
          onBlur={onUpdate.bind(this, this.props.onUpdate)}
          onKeyPress={onUpdate.bind(this, this.props.onUpdate)}
          tabIndex={this.props.tabIndex}
          lang={this.props.type === "number" ? "fr" : ""}
        />
        {this.props.postfix && <span style={{marginLeft: 5}}>{this.props.postfix}</span>}
      </label>
    );
  }

}

function onUpdate(callback, e) {
  if (!e.key || e.key === 'Enter') {
    if ((this.props.minValue !== undefined && +e.target.value < this.props.minValue) || 
      (this.props.maxValue !== undefined && +e.target.value > this.props.maxValue)) {
      if (this.inputElement && this.inputElement.current) {
        this.inputElement.current.value = this.props.value;
      }
    }
    else if (callback) callback(e.target.value);
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js